/* KANON `Programy v2 - D3 (0.8)` — what a TEMPLATE row adds to the shared anatomy.
 *
 * Everything a template row has in common with a client's plan is in `listRow.module.css`: the grid
 * shell, the selection, the stretched link, the cover, the name over its sub-line, the mode mark.
 * What is left here is this row's own grid and height.
 *
 * Read off the rendered specimen at 1512×1000, then re-cut a fifth taller by owner decision D28 of
 * 4 September 2026, and cut down by the owner's polish of 4 November 2026:
 *   row      grid `61px minmax(0,1fr) auto`, height 73 (canon: 51 / 86.5 / 83, height 61)
 *
 * The canon's last two tracks were the mode (word and mark, 108 here) and the follower count (48).
 * The polish took the follower count to the inspector hero and the mode's word into the mark's
 * hidden name, so the row ends on the 16px mark: an `auto` track that is exactly as wide as the mark,
 * and every pixel the two fixed tracks held goes to the flexible name column instead.
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js); every colour,
 * space, radius and type value below is a token. */

.row {
  grid-template-columns: var(--w-pl-cover) minmax(0, 1fr) auto;
  height: var(--h-pl-row);
}
